import * as React from 'react';
import { closeViewFromSeatModal, openViewFromSeatModal } from '../../../actions/app-actions';
import { IAltText } from '../../../classes/alt-text';
import { getSeatViewThumbUrl, getSeatViewUrl } from '../../actions/seatmap-fetch';


export interface ISeatInfoImageProps {
    seatViewImageId: string;
    altText: IAltText;
    viewFromSeatModalActive: boolean;
    dispatch: any;
    seatViewCaptionText: string;
    isSmallView?: boolean;
    onSelect: (e: any) => void;
}

interface ISeatInfoImageState {
    phonePanned: boolean,
    seatViewTransform: number,
    currentGamma: number
}

class SeatInfoImage extends React.Component<ISeatInfoImageProps, ISeatInfoImageState> {

    dispatch: any;
    onSelect: (e: any) => void;

    constructor(props) {
        super(props);

        this.state = {
            phonePanned: false,
            seatViewTransform: -50,
            currentGamma: 0,
        };

        this.dispatch = this.props.dispatch;
        this.onSelect = this.props.onSelect;
    }

    render() {

        const { seatViewImageId, altText, seatViewCaptionText, isSmallView } = this.props;
        const { seatViewMagnifyingGlassSvg } = altText;
        const useTagPlus = `<use xlink:href="#icon-search-plus" />`;
        const useTagMinus = '<use xlink:href="#icon-search-minus" />';
        const useTagClose = '<use xlink:href="#icon-close" />';
        const closeText = 'Close';

        const seatViewImageSrc = getSeatViewUrl(seatViewImageId);
        const seatViewImageThumbSrc = getSeatViewThumbUrl(seatViewImageId) || seatViewImageSrc;

        if (seatViewImageThumbSrc) {
            var imageStyle = isSmallView ? {} : { transform: "translateY(-50%) translateX(-50%)" };
            const classNameSeatView = `seat-info-views ${seatViewImageThumbSrc.length > 0 ? 'has-img' : ''} ${this.props.viewFromSeatModalActive ? 'open' : ''}`;
            const classNameSeatSmallView = `seat-info-views cart-item-imagecontainer`;
            const classNameSeatViewContainer = isSmallView ? classNameSeatSmallView : classNameSeatView;

            return (
                <div className={classNameSeatViewContainer} style={{ backgroundImage: isSmallView ? 'none' : `url(${seatViewImageThumbSrc})` }}>
                    <img className={`seat-info-views-smallimage ${isSmallView ? 'cart-item-image' : ''}`} alt="View from this seat." id={`seatViewImg-${seatViewImageId}`} style={imageStyle} src={seatViewImageThumbSrc} />
                    <button className="seat-info-views-button plus" type="button" onClick={() => this._openSeatView()}>
                        <span className="visually-hidden">{seatViewMagnifyingGlassSvg}</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagPlus }} />
                    </button>
                    <button className="seat-info-views-button minus" type="button" onClick={() => this._closeSeatView()}>
                        <span className="visually-hidden">{closeText}</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagMinus }} />
                    </button>
                    <button className="seat-info-views-button close" type="button" onClick={() => this._closeSeatView()}>
                        <span className="visually-hidden">{closeText}</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagClose }} />
                    </button>
                    {
                        !isSmallView && seatViewCaptionText &&
                        <div className="seat-info-views-caption">
                            <p className="caption-paragraph">{seatViewCaptionText}</p>
                        </div>
                    }

                    <div className="seat-info-views-largeimage">
                        <div className="seat-info-views-trigger" onClick={() => this._closeSeatView()}></div>
                        <div className="seat-info-views-largeimage-inner">
                            <img src={seatViewImageSrc} alt="View from this seat." id={`seatViewImgLarge-${seatViewImageId}`} style={imageStyle} />
                            <button className="seat-info-views-button plus" type="button" onClick={() => this._openSeatView()}>
                                <span className="visually-hidden">{seatViewMagnifyingGlassSvg}</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagPlus }} />
                            </button>
                            <button className="seat-info-views-button minus" type="button" onClick={() => this._closeSeatView()}>
                                <span className="visually-hidden">{closeText}</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagMinus }} />
                            </button>
                            <button className="seat-info-views-button close" type="button" onClick={() => this._closeSeatView()}>
                                <span className="visually-hidden">{closeText}</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagClose }} />
                            </button>
                            <div className="seat-info-views-largeimage-inner-caption">
                                <p className="caption-paragraph">{seatViewCaptionText}</p>
                            </div>
                        </div>

                    </div>
                </div >
            );
        }

        return null;
    }

    _openSeatView() {
        if (this.onSelect){
            this.onSelect(null);
        }

        this.dispatch(openViewFromSeatModal());
    }

    _closeSeatView() {
        this.dispatch(closeViewFromSeatModal());
    }
}

export default SeatInfoImage;